import React, { useState, useEffect, useRef } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Sidebar from "../Components/Sidebar";
import Topbar from "../Components/Topbar";
import Vendordashboard from "./Vendordashboard";
import Exchange from "./Exchange";
import Orders from "./Orders";
import Products from "./Products";
// import Discount from "./Discount";
import Reports from "./Reports";
import Settings from "./Settings";
import "../App.css";
import Orderid from "./Orderid";
import Payments from "./Payments";
import Stock from "./Stock";
import Profile from "./Profile";
import Help from "./Help";
import axios from "axios";
import Members from "./Members";
import Logs from "./Logs";
import Quotation from "./Quotation";

function Vendorhomepage({ sendotp, verifyotp }) {
  const [products, setProducts] = useState([]);
  const [orders, setOrders] = useState([]);
  const [dashboard, setDashboard] = useState({
    Cards: [],
    Category: [],
    MonthWise: [],
    ProductWise: [],
    Review: [],
  });
  const [vendor, setVendor] = useState({
    vendor: [],
    sub: [],
  });
  const [payment, setPayment] = useState([]);
  const [logs, setLogs] = useState([]);
  const [quotation, setQuotation] = useState([]);

  const location = useLocation();
  const fetchedRef = useRef(false);

  const VendorDetails = JSON.parse(localStorage.getItem("vendorData"));


  const fetchproducts = async () => {
    const formData = new FormData();
    formData.append("type", "vendor");
    formData.append("vendor_id", VendorDetails?.id);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/prod_show.php`,
        formData
      );
      const data = res.data?.data || res.data;
      if (Array.isArray(data)) {
        setProducts(data);
      }
    } catch (err) {
      console.error("Error fetching orders", err);
    }
  };

  const fetchOrders = async () => {
    const formData = new FormData();
    formData.append("type", "vendor");
    formData.append("id", VendorDetails?.id);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/order_show.php`,
        formData
      );
      const data = res.data?.data || res.data;
      if (Array.isArray(data)) {
        setOrders(data);
      }
    } catch (err) {
      console.error("Error fetching orders", err);
    }
  };

  const fetchDashboard = async () => {
    const formData = new FormData();
    formData.append("vendor_id", VendorDetails?.id);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/vendor/dashboard.php`,
        formData
      );

      const fullData = res.data;
      if (fullData?.data && Array.isArray(fullData.data)) {
        setDashboard((pv) => ({
          ...pv,
          Cards: fullData.data[0],
          Category: fullData.data1 || [],
          MonthWise: fullData.data2 || [],
          ProductWise: fullData.data3 || [],
        }));
      } else {
        console.warn("Unexpected response structure", fullData);
      }
    } catch (err) {
      console.error("Error fetching dashboard data", err);
    }
  };

  const fetchreview = async () => {
    const formData = new FormData();
    formData.append("vendor_id", VendorDetails?.id);
    formData.append("type", "vendor");

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/review_show.php`,
        formData
      );

      const fullData = res.data;
      if (fullData?.data && Array.isArray(fullData.data)) {
        setDashboard((pv) => ({
          ...pv,
          Review: fullData.data || [],
        }));
      } else {
        console.warn("Unexpected response structure", fullData);
      }
    } catch (err) {
      console.error("Error fetching dashboard data", err);
    }
  };

  const fetchvendor = async () => {
    const formData = new FormData();
    formData.append("id", VendorDetails?.id);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/vendor/vendor_show.php`,
        formData
      );
      const data = res.data?.data || res.data;
      if (Array.isArray(data)) {
        setVendor((pv) => ({
          ...pv,
          vendor: data[0],
        }));
      }
    } catch (err) {
      console.error("Error fetching orders", err);
    }
  };

  const fetchsub = async () => {
    const formData = new FormData();
    formData.append("vendor_id", VendorDetails?.id);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/vendor/subscriber_show.php`,
        formData
      );
      const data = res.data?.data || res.data;
      if (Array.isArray(data)) {
        setVendor((pv) => ({
          ...pv,
          sub: data,
        }));
      }
    } catch (err) {
      console.error("Error fetching orders", err);
    }
  };

  const fetchpayment = async () => {
    const formData = new FormData();
    formData.append("vendor_id", VendorDetails?.id);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/payment_show.php`,
        formData
      );
      const data = res.data?.data || res.data;
      if (Array.isArray(data)) {
        setPayment(data);
      }
    } catch (err) {
      console.error("Error fetching payment", err);
    }
  };

  const fetchLogs = async () => {
    const formData = new FormData();
    formData.append("vendor_id", VendorDetails?.id);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/vendor/notification_show.php`,
        formData
      );
      const data = res.data || res.data?.data;
      if (data.status === "success") {
        setLogs(data?.data);
      } else {
        console.error("Error response Logs ", data.status || "no status");
      }
    } catch (err) {
      console.error("Error fetching Logs", err);
    }
  };

  const fetchQuotation = async () => {
    const formData = new FormData();
    formData.append("vendor_id", VendorDetails?.id);
    formData.append("type", "vendor");

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/vendor/quotation_show.php`,
        formData
      );
      const data = res.data || res.data?.data;
      if (data.status === "success") {
        setQuotation(data?.data);
      } else {
        console.error("Error response Logs ", data.status || "no status");
      }
    } catch (err) {
      console.error("Error fetching Logs", err);
    }
  };

  useEffect(() => {
    if (fetchedRef.current) return;

    fetchedRef.current = true;
    fetchDashboard();
    fetchreview();
    fetchOrders();
    fetchproducts();
    fetchvendor();
    fetchsub();
    fetchpayment();
    fetchLogs();
    fetchQuotation();
  }, []);

  let filteredProducts = [...orders];
  if (location.pathname === "/vendor/exchange") {
    filteredProducts = orders.filter((item) =>
      ["exchange", "return"].includes(item.order_status?.toLowerCase())
    );
  } else if (location.pathname === "/vendor/orders") {
    filteredProducts = orders.filter(
      (item) =>
        !["exchange", "return"].includes(item.order_status?.toLowerCase())
    );
  } else if (location.pathname === "/vendor/vendordashboard") {
    filteredProducts = orders.slice(0, 5);
  }

  const [parsedLinks, setParsedLinks] = useState({});

  useEffect(() => {
    if (vendor.vendor.link) {
      try {
        const parsed = JSON.parse(vendor.vendor.link);
        setParsedLinks(parsed);
      } catch (e) {
        console.error("Invalid link JSON", e);
      }
    }
  }, [vendor.vendor.link]);

  return (
    <div className="app-container">
      <Sidebar />
      <div className="main-content">
        <Topbar vendor={vendor?.vendor} />
        <Routes>
          <Route index element={<Vendordashboard />} />
          <Route
            path="vendordashboard"
            element={
              <Vendordashboard
                orders={filteredProducts}
                dashboard={dashboard}
              />
            }
          />
          <Route path="orders" element={<Orders orders={filteredProducts} />} />
          {/* <Route path="orders/orderid" element={<Orderid  orders={orders}/>} /> */}
          {/* <Route path="orders/orderid/:orderid" element={<Orderid orders={orders} />} /> */}
          <Route
            path="vendor/orders/orderid/:orderid"
            element={<Orderid orders={orders} />}
          />

          <Route
            path="exchange"
            element={<Exchange orders={filteredProducts} />}
          />
          <Route
            path="products"
            element={<Products products={products} fetchprod={fetchproducts} />}
          />
          {/* <Route path="discount" element={<Discount />} /> */}
          {/* <Route
            path="stock"
            element={<Stock products={products} fetchprod={fetchproducts} />}
          /> */}
          <Route path="reports" element={<Reports products={products} />} />
          <Route
            path="invoiceandpayments"
            element={<Payments payment={payment} cards={dashboard?.Cards} />}
          />
          <Route
            path="logs"
            element={<Logs logs={logs} />}
          />
          <Route
            path="quotation"
            element={<Quotation quotations={quotation} />}
          />
          <Route path="workers" element={<Members />} />
          <Route
            path="profile"
            element={
              <Profile
                vendor={vendor?.vendor}
                fetchvendor={fetchvendor}
                parsedLinks={parsedLinks}
              />
            }
          />
          <Route
            path="settings"
            element={
              <Settings
                vendor={vendor?.vendor}
                sub={vendor?.sub}
                fetchvendor={fetchvendor}
                sendotp={sendotp}
                verifyotp={verifyotp}
                parsedLinks={parsedLinks}
              />
            }
          />
          <Route path="help" element={<Help />} />
        </Routes>
      </div>
    </div>
  );
}

export default Vendorhomepage;
